import React, {Component} from "react";
import PropTypes from "prop-types";
import {Icon, Spin} from "antd";

const propTypes = {
    children: PropTypes.node
};

const defaultProps = {};

export var showProgressFooter = function () {
    this.setState({hiddenProgress: false});
};
export var hideProgressFooter = function () {
    this.setState({hiddenProgress: true});
};

class DefaultFooter extends Component {

    state = {
        hiddenProgress: true,
    };

    constructor(props) {
        super(props);
        showProgressFooter = showProgressFooter.bind(this);
        hideProgressFooter = hideProgressFooter.bind(this);
    }

    render() {
        // eslint-disable-next-line
        const {children, ...attributes} = this.props;

        return (
            <React.Fragment>

                <Spin indicator={<Icon type="loading" style={{fontSize: 20}} spin/>}
                      hidden={this.state.hiddenProgress}/>
                <span className="ml-auto">
          <a href={process.env.PUBLIC_URL + "/"}>ITEL</a> &copy; 2020.
        </span>
            </React.Fragment>
        );
    }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;
